<template>
  <b-row class="d-flex align-items-center">
    <b-col class="col-12 col-lg-3 col-xl-3 col-xxl-3">
      <b-card no-body>
        <b-card-header>
          <h4 class="mb-0 mx-auto analytics-title">
             {{ $t('campaigns.overviewCmapaign') }}
          </h4>
        </b-card-header>

        <component
          :is="apex_charts"
          type="radialBar"
          height="245"
          :options="graph.chartOptions"
          :series="graph.series"
        />
        <b-row class="text-center mx-0">
          <b-col
            cols="6"
            class="border-top border-right d-flex align-items-between flex-column py-1"
          >
            <b-card-text class="text-muted mb-0">
               {{ $t('campaigns.influencer') }}
            </b-card-text>
            <h3 class="font-weight-bolder mb-50">
              {{influencers_approved}}
            </h3>
          </b-col>

          <b-col
            cols="6"
            class="border-top d-flex align-items-between flex-column py-1"
          >
            <b-card-text class="text-muted mb-0">
               {{ $t('campaigns.contentPublished') }}
            </b-card-text>
            <h3 class="font-weight-bolder mb-0">
              {{published}}
            </h3>
          </b-col>
        </b-row>
      </b-card>
    </b-col>

    <b-col class="col-12  col-lg-9 col-xl-9 col-xxl-9">

      <b-row>
        <b-col cols="12" class="text-right">
          
        <b-dropdown
          id="dropdown-right"
          :text="$t('campaigns.actions')"
          variant="flat-secondary"
          class="avenir-medium mb-1 dropdown-actions"
          right
        >
          <b-dropdown-item @click="dowloadCsv()">
            <b-icon
              font-scale="1"
              icon="file-earmark-excel"
              />
              {{ $t('campaigns.export') }}
          </b-dropdown-item>
          <b-dropdown-item @click="print()">
            <b-icon
            font-scale="1"
            icon="printer"
            id="btnPrint"
            />
            {{$t('print')}}
          </b-dropdown-item>
        </b-dropdown>
        </b-col>
      </b-row>

      <b-card no-body>
        <b-card-header>
          <h4 class="mb-0 analytics-title">
             {{ $t('campaigns.infGeneral') }}
          </h4>
          <b-card-text class="text-muted mb-0">
             {{ $t('campaigns.updated') }}
          </b-card-text>
        </b-card-header>

        <b-row>
          <b-col>
            <feather-icon icon="InfoIcon" class="text-muted float-right mt-2 mr-2 cursor-pointer" size="20" id="views-tooltip"/>
            <b-popover triggers="hover" placement="top" target="views-tooltip">
              {{$t('campaigns.viewsTooltip')}}
            </b-popover>
            <statistic-card-horizontal
              icon="TrendingUpIcon"
              :statistic="numberFormat(impressions)"
              :statistic-title="$t('campaigns.views')"
            />
          </b-col>
          
          <b-col>
            <feather-icon icon="InfoIcon" class="text-muted float-right mt-2 mr-2 cursor-pointer" size="20" id="reach-tooltip"/>
            <b-popover triggers="hover" placement="top" target="reach-tooltip">
              {{$t('campaigns.reachTooltip')}}
            </b-popover>
            <statistic-card-horizontal
              icon="UsersIcon"
              color="warning"
              :statistic="numberFormat(total_scope, false, true)"
              :statistic-title="$t('scope_number_total')"
            />
          </b-col>

          <b-col>
            <feather-icon icon="InfoIcon" class="text-muted float-right mt-2 mr-2 cursor-pointer" size="20" id="interaction-tooltip-1"/>
            <b-popover triggers="hover" placement="top" target="interaction-tooltip-1">
              {{$t('campaigns.interactionTooltip')}}
            </b-popover>
            <statistic-card-horizontal
              icon="UserIcon"
              color="info"
              :statistic="numberFormat(engagements_number)"
              :statistic-title="$t('campaigns.engagementsTotal')"
            />
          </b-col>

          <b-col>
            <feather-icon icon="InfoIcon" class="text-muted float-right mt-2 mr-2 cursor-pointer" size="20" id="er-tooltip"/>
            <b-popover triggers="hover" placement="top" target="er-tooltip">
              {{$t('campaigns.erTootip')}}
            </b-popover>
            <statistic-card-horizontal
              icon="BoxIcon"
              color="danger"
              :statistic="`${numberFormat(decimalFixed(er, 1))} %`"
              statistic-title="ER %"
            />
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BCardHeader, BCardText, BIcon, BButton, BCardBody, BAvatar, BDropdown, BDropdownItem, BPopover
} from 'bootstrap-vue'
import { $themeColors } from '@themeConfig'
import campaign_service from '@/services/campaign';
import { numberFormat, decimalFixed, capitalize, getFormattedDateTime } from '@/libs/utils/formats';
const toast_notification = () => import('@core/components/toastification/ToastificationContent.vue')
import { getMotivationalPhrase, getTypeInfluencer } from '@/libs/utils/others';
import { getDatev2 } from '@/libs/utils/times';

export default {
  name: 'ResumeAnalytics',
  props: {
    influencers_approved: {
      type: Number,
      default: 0
    },
    published: {
      type: Number,
      default: 0
    },
    engagements: {
      type: Object,
      default: () => {}
    },
    followers: {
      type: Number,
      default: 0
    },
    clicks: {
      type: Number,
      default: 0
    },
    campaingName: {
      type: String,
      default: ''
    },
    analytics_overwrite: {
      type: Object,
    },
    networks: {
      type: Array,
      default: () => []
    }
  },
  components: {
    BPopover,
    BDropdown,
    BDropdownItem,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardText,
    BIcon,
    BButton,
    BCardBody,
    BAvatar,
    StatisticCardHorizontal: () => import('@core/components/statistics-cards/StatisticCardHorizontal.vue'),
    priceManaged: () => import('../../priceManaged.vue'),
  },
  data() {
    return {
      decimalFixed,
      numberFormat,
      contents: [],
      percentage_published: 0,
      impressions: 0,
      engagements_number: 0,
      er: 0,
      total_scope: 0,
      mutable_clicks: this.clicks,
      graph: {
        series: [0],
        chartOptions: {
          chart: {
            sparkline: {
              enabled: true,
            },
            dropShadow: {
              enabled: true,
              blur: 3,
              left: 1,
              top: 1,
              opacity: 0.1,
            },
          },
          colors: ['#51e5a8'],
          plotOptions: {
            radialBar: {
              offsetY: -10,
              startAngle: -150,
              endAngle: 150,
              hollow: {
                size: '77%',
              },
              track: {
                background: '#ebe9f1',
                strokeWidth: '50%',
              },
              dataLabels: {
                name: {
                  show: false,
                },
                value: {
                  color: '#5e5873',
                  fontSize: '2.86rem',
                  fontWeight: '600',
                },
              },
            },
          },
          fill: {
            type: 'gradient',
            gradient: {
              shade: 'dark',
              type: 'horizontal',
              shadeIntensity: 0.5,
              gradientToColors: [$themeColors.success],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100],
            },
          },
          stroke: {
            lineCap: 'round',
          },
          grid: {
            padding: {
              bottom: 30,
            },
          },
        },
      },
      apex_charts: null,
    }
  },
  beforeCreate() {
    campaign_service.getCampaignManage(this.$route.params.uuid).then((response) => {
      this.contents = this.formatPublished(response.results)
    });
  },
  created() {
    if (this.published >= this.influencers_approved) {
      this.percentage_published = 100
    } else if (this.published === 0) {
      this.percentage_published = 0
    } else {
      this.percentage_published = (this.published * 100) / this.influencers_approved
    }
    this.graph.series = [numberFormat(decimalFixed(this.percentage_published, 2))]
    this.formatData();
  },
  async mounted() {
    this.apex_charts = (await import('vue-apexcharts')).default;
  },
  methods: {
    formatPublished(influencers) {
      const data = [];
      influencers.forEach(influencer => {
        influencer.content.forEach((content) => {
          content['username'] = influencer.influencer.username;
          content['category'] = influencer.influencer.calculate_category;
          content['image'] = influencer.influencer.profile_url;
          content['followers'] = influencer.influencer.followers;
          content['engagement'] = decimalFixed(influencer.influencer.engagement_rate, 2),
          content['profile_url'] = influencer.influencer.profile_url;
          content['file_for_profile'] = influencer.influencer.file_for_profile;
          content['network_influencer'] = influencer.influencer.network.toLowerCase();
          content['name'] = influencer.influencer.name;

          data.push(content)
        })
      })
      return data;
    },
    dowloadCsv() {
      this.$vs.loading({
        type: 'sound',
        background: 'rgba(255, 255, 255, 1)',
        text: getMotivationalPhrase(),
      });

      this.interval_loading = setInterval(() => {
        const prev_loading = document.getElementsByClassName('con-vs-loading')[0]

        if (prev_loading) {
          prev_loading.classList.add('fade-out');
          setTimeout(function() {
            prev_loading.remove()
          }, 500);

          this.$vs.loading({
            type: 'sound',
            background: 'rgba(255, 255, 255, 1)',
            text: getMotivationalPhrase(),
          });
        }
      }, 5000);
      const rows = [
        [
          'Influencer',
          'Tipo de influencer',
          'Red social',
          'Seguidores',
          'Estatus',
          'Tipo de contenido',
          'Fecha publicación',
          'Impresiones',
          'Likes',
          'Comentarios',
          'Shares',
          'Saves',
          'Última fecha de actualización',
          'Url contenido'
        ]
      ];
      this.contents.forEach(data => {
        rows.push([
          data.username,
          getTypeInfluencer(data.category),
          capitalize(data.network),
          data.followers,
          this.$t(`campaigns.statuses.${data.status}`),
          this.$t(data.content_type),
          data.published_date,
          data.number_of_impressions > 0 ? data.number_of_impressions : '-',
          data.number_of_likes > 0 ? data.number_of_likes : '-',
          data.number_of_comments > 0 ? data.number_of_comments : '-',
          data.number_of_shares > 0 ? data.number_of_shares : '-',
          data.number_of_times_saved > 0 ? data.number_of_times_saved : '-',
          getDatev2(new Date(data.updated_at)),
          data.url_info ? data.url_info : '-'
        ])
      })

      const csv = rows.map(e => e.join(",")).join("\n")
      const downloadLink = document.createElement("a");
      const blob = new Blob(["\ufeff", csv]);
      const url = URL.createObjectURL(blob);

      downloadLink.href = url;
      downloadLink.download = `Influencers BrandMe ${this.campaingName} ${getFormattedDateTime()}.csv`;

      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      const self = this
      setTimeout(() => {
        clearInterval(this.interval_loading)
        self.$vs.loading.close();
      }, 200)
    },
    changeClicks(new_clicks) {
      if (this.mutable_clicks !== new_clicks) {
        this.mutable_clicks = new_clicks
        const form = new FormData();
        form.append('clicks', new_clicks);
        campaign_service.updateCampaign(this.$route.params.uuid, form).then(() => {
          toast_notification().then((toast) => {
            this.$toast({
              component: toast.default,
              position: 'top-right',
              props: {
                title: this.$t('campaigns.success_update_budget_title'),
                icon: 'CoffeeIcon',
                variant: 'success',
                text: this.$t('campaigns.success_update_clicks_text')
              }
            })
          })
        })
      }
    },
    print() {
      this.$emit('print-requested');
    },
    formatData() {
      let total_impressions = 0;
      let total_scope = 0;
      this.networks.forEach((network) => {
        total_impressions += network.total_views;
        total_scope += network.total_reach;
      });
      this.impressions = total_impressions;
      this.number_of_comments = this.engagements.number_of_comments || 0;
      this.number_of_likes = this.engagements.number_of_likes || 0;
      this.number_of_shares = this.engagements.number_of_shares || 0;
      this.engagements_number = this.engagements.engagements || 0;

      if (this.impressions > 0) {
        this.er = (this.number_of_comments + this.number_of_likes + this.number_of_shares) / this.impressions * 100;
      } else {
        this.er = 0;
      }

      if (total_impressions <= 0) {
        this.impressions = total_scope
        this.total_scope = Math.round(decimalFixed((this.impressions * 75.17) / 100));
        this.er = (this.number_of_comments + this.number_of_likes + this.number_of_shares) / this.impressions * 100;
      } else {
        this.total_scope = total_scope;
      }
    }
  },
}
</script>
<style scoped lang="scss">
.dropdown-actions {
  width: auto;
  margin-right: 1em;
  z-index: 110;
  @media (max-width: 991.98px) {
    width: 100%;
    margin-right: 0;
  }
}
</style>

